import { axiosObject } from "../config";

function getEligibleBidderByEmail(email: any) {
    return new Promise((resolve, reject) => {
        let uri = `auction/data/resource/eligible-bidders/_read`;
        let payload = {
            apiConfig: {
                includeRelations: "*",
                includeMutations: "*"
            },
            limitBy: {
                per_page: 10,
                page: 1
            },
            sortBy: [{ attribute: "created_at", order: "desc" }],
            filterBy: [
                {
                    attribute: "email",
                    op: "eq",
                    value: email
                }
            ]
        }

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}

function updateEligibleBiddersWithUserUuid(bidder_uuid: string, user_uuid: string) {
    return new Promise((resolve, reject) => {
        let uri = `auction/data/resource/eligible-bidders/_patch`;
        let payload = {
            uuid: bidder_uuid,
            user_uuid: user_uuid
        }

        axiosObject
            .post(uri, payload)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}


export { getEligibleBidderByEmail, updateEligibleBiddersWithUserUuid }